'use client';

import { Button, type ButtonProps } from '@andritzot/metris-web-ui/inputs/button';
import { type ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ButtonContext } from './ButtonContext';

interface CustomButtonRootProps extends ButtonProps {
  readonly children: ReactNode;
  readonly buttonText?: ReactNode;
}

const CustomButtonRoot = ({ children, buttonText, ...props }: CustomButtonRootProps) => {
  const id = uuidv4().split('-')[0];
  return (
    <ButtonContext.Provider value={id}>
      {children}
      <Button id={id} {...props}>{buttonText}</Button>
    </ButtonContext.Provider>
  );
};

export default CustomButtonRoot;
